var _rect, _rect2, _rect3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLeftBtnIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 26,
    viewBox: "0 0 20 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 10.3594,
    width: 6.13013,
    height: 6.13013,
    rx: 1,
    transform: "rotate(-45 0.5 10.3594)",
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 10.2656,
    y: 3.56592,
    width: 4.5797,
    height: 4.5797,
    rx: 1,
    transform: "rotate(-45 10.2656 3.56592)",
    fill: "white"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 7.82428,
    y: 19.187,
    width: 8.25602,
    height: 8.25602,
    rx: 1,
    transform: "rotate(-45 7.82428 19.187)",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeftBtnIcon);
export default __webpack_public_path__ + "static/media/leftBtnIcon.f9307ae852a9617540d7fa9eb915e95f.svg";
export { ForwardRef as ReactComponent };